/**
 * @file paddle 客户案例
 * @author wanzhongyun
 */

import React from 'react';
import {Button} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Banner from '../../components/banner/Banner';
import Footer from '../../components/footer/Footer';
import VideoTextCard from './components/video-text-card/VideoTextCard';
import VerticalTabText from './components/vertical-tab-text/VerticalTabText';

import useCustomerCaseHooks from './customerCaseHooks';
import EnterpriseCaseList from './components/case-list/EnterpriseCaseList';
// import RightNavigation from '../../components/right-navigation/RightNavigation';
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';


const IndexIndex: React.FC = () => {
    const {
        banner,
        enterpriseCaseIntroduce,
        enterpriseCaseCaseSelection,
        caseList
    } = useCustomerCaseHooks();



    return (
        <div className="page paddle-cc-page">
            {
                (caseList.length > 0 && banner?.title) && <div>
                    <Header />
                    <Banner
                        className="paddle-cc-page-banner"
                        title={banner?.title}
                        subtitle={banner?.subtitle}
                    >
                        {(banner?.btns.length ?? 0) > 0
                        && (
                            <div className="paddle-hub-index-page-banner-btn-group">
                                {banner?.btns.map((btn) => (
                                    <a
                                        key={`${btn.title}${btn.href}`}
                                        href={btn.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <Button
                                            type="primary"
                                            size="large"
                                            className="paddle-hub-index-page-banner-btn"
                                        >
                                            {btn.title}
                                        </Button>
                                    </a>
                                ))}
                            </div>
                        )}
                    </Banner>

                    <div>
                        <ReactStickyPolyfill>
                            <div className="paddle-cc-page-tabs-title-wrap-line" />
                        </ReactStickyPolyfill>
                        <div className="paddle-cc-content">
                        {!!enterpriseCaseIntroduce
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {enterpriseCaseIntroduce.cardTitle}
                                    </div>
                                    <VideoTextCard
                                        {...enterpriseCaseIntroduce}
                                    />
                                </div>
                            )}
                            {!!enterpriseCaseCaseSelection
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {enterpriseCaseCaseSelection.title}
                                    </div>
                                    <VerticalTabText
                                        {...enterpriseCaseCaseSelection}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="paddle-cc-page-grey">
                            <div className="paddle-cc-content-wide">
                                <div className="paddle-cc-content">
                                    <div className="paddle-cc-content-item">
                                        <div
                                            className="paddle-cc-content-h1"
                                        >
                                            Partners of PaddlePaddle
                                        </div>
                                        <EnterpriseCaseList caseList={caseList} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            }
        </div>
    );
};

export default IndexIndex;
